import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Pagination } from '@material-ui/lab';
import {
  Grid,
  Button,
  makeStyles,
  Popover,
  useMediaQuery,
} from '@material-ui/core';

//import { withStyles } from '@material-ui/styles';

import MainTitle from '../../../components/MainTitle';
import CardProposal from '../../../components/Cards/CardProposal';
import ProposalFilter from '../ProposalFilter';
import Results from './Results';
import {
  getProposalsByPage,
  setProposalSelected,
} from '../../../store/actions/ProposalsAction';
import PopUp from '../../../components/Modal/PopUp';

const useStyles = makeStyles({
  contentContainer: {
    maxWidth: 944,
    margin: '0 auto',
    paddingBottom: 112,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    margin: '41px 0 24px',
  },
  filterButton: {
    width: 120,
    height: 40,
    borderRadius: 20,
    border: '1px solid #013957',
    textTransform: 'inherit',
    backgroundColor: 'transparent',
    color: '#013957',
    fontSize: 16,
    margin: '0 24px 0 0',
  },
  filterIcon: {
    margin: '0 10px 0 0',
  },
  createProposal: {
    width: 304,
    height: 40,
    borderRadius: 20,
    textTransform: 'inherit',
    backgroundColor: '#013957',
    color: 'white',
    fontSize: 16,
    '&:hover': {
      backgroundColor: '#35b9b6',
    },
  },
  paperFilter: {
    backgroundColor: 'white',
    padding: 24,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
  },
  pagination: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 56,
  },
});

const ProposalList = ({
  handleClickCreate,
  getProposalsByPage,
  proposals,
  searchValues,
  setSearchValues,
  uid,
  setProposalSelected,
  setCreateView,
  setShowPreview,
}) => {

  const classes = useStyles();
  //const mobileView = useMediaQuery('(max-width: )');
  const [anchorEl, setAnchorEl] = useState(null);

  const [paginationParams, setPaginationParams] = useState({});

  const openPopover = Boolean(anchorEl);
  const handleClickFilter = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleChangePage = async (event, value) => {
    window.scrollTo(0, 0);
    try {
      const params = {
        page: value,
        limit: 9,
        uid: uid,
      };
      await getProposalsByPage(params);
    } catch (error) {
      throw error;
    }
  };

  return (
    <div className={classes.contentContainer}>
      <MainTitle
        title="Propuesta económica"
        subtitle="Crea y comparte propuestas económicas con clientes dentro y fuera de Contacta Abogado®."
      />

      <div className={classes.buttonsContainer}>
        <Button
          type="button"
          onClick={handleClickFilter}
          className={classes.filterButton}
        >
          <img
            src="/img/icons/filters.svg"
            alt="filter"
            className={classes.filterIcon}
          />
          Filtros
        </Button>
        <Button
          type="submit"
          onClick={handleClickCreate}
          className={classes.createProposal}
        >
          Crear propuesta económica
        </Button>
      </div>
      <div>
        {searchValues.length > 0 && proposals && proposals.totalItems ? (
          <Results
            searchValues={searchValues}
            proposals={
              proposals && proposals.totalItems && proposals.totalItems
            }
            filterResult
          />
        ) : null}
        <Grid container spacing={2}>
          {proposals &&
            proposals.data &&
            proposals.data.map((proposal, index) => (
              <Grid item key={index} xs={12} sm={6} md={4}>
                <CardProposal proposal={proposal} setCreateView={setCreateView} setShowPreview={setShowPreview} />
              </Grid>
            ))}
        </Grid>

        {proposals &&
        proposals.totalPages &&
        (proposals.totalPages <= 1 ||
          proposals.totalPages === 0) ? null : proposals.totalPages ===
          0 ? null : (
          <div className={classes.pagination}>
            <Pagination
              color="primary"
              count={proposals.totalPages}
              page={proposals.actualpage}
              onChange={handleChangePage}
            />
          </div>
        )}
      </div>

      {proposals && proposals.totalItems === 0 && (
        <Results
          searchValues={searchValues}
          //proposals={proposals && proposals.totalItems && proposals.totalItems}
        />
      )}

      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        //className={classes.popover}
        onClose={() => setAnchorEl(null)}
        classes={{ paper: classes.paperFilter }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <ProposalFilter
          handleClickFilter={handleClickFilter}
          setSearchValues={setSearchValues}
          uid={uid}
        />
      </Popover>
    </div>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  proposals: state.proposalsReducer.proposals,
  proposalData: state.proposalsReducer.selectedProposal,
});

const mapDispatchToProps = (dispatch) => ({
  getProposalsByPage: (params) => dispatch(getProposalsByPage(params)),
  setProposalSelected: (proposalData) =>
    dispatch(setProposalSelected(proposalData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProposalList);
